import { render } from "./AdminManagement.vue?vue&type=template&id=0c77d2ab&scoped=true"
import script from "./AdminManagement.vue?vue&type=script&lang=js"
export * from "./AdminManagement.vue?vue&type=script&lang=js"

import "./AdminManagement.vue?vue&type=style&index=0&id=0c77d2ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c77d2ab"]])

export default __exports__